<div class="sign-in-container">
  <div class="sign-in-card">
    <!-- Header -->
    <div class="auth-header">
      @if (!showOtpStep()) {
        <h1 class="auth-title">Welcome Back</h1>
        <p class="auth-subtitle">Sign in to your account to continue</p>
      } @else {
        <h1 class="auth-title">Verify Your Identity</h1>
        <p class="auth-subtitle">Enter the 6-digit code sent to {{ email() }}</p>
      }
    </div>

    <!-- Sign In Form -->
    <form (ngSubmit)="onSubmit()" class="auth-form">
      @if (!showOtpStep()) {
        <!-- Password Step -->
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <input
            type="email"
            id="email"
            pInputText
            [(ngModel)]="email"
            name="email"
            placeholder="Enter your email"
            class="form-input"
            [class.error]="error()"
            autocomplete="email"
            [disabled]="loading()"
          />
        </div>

        <div class="form-group">
          <label for="password" class="form-label">Password</label>
          <input
            type="password"
            id="password"
            pInputText
            [(ngModel)]="password"
            name="password"
            placeholder="Enter your password"
            class="form-input"
            [class.error]="error()"
            autocomplete="current-password"
            [disabled]="loading()"
          />
        </div>
      } @else {
        <!-- OTP Step -->
        <div class="form-group">
          <label for="otp" class="form-label">Verification Code</label>
          <input
            type="text"
            id="otp"
            pInputText
            [(ngModel)]="otp"
            name="otp"
            placeholder="Enter 6-digit code"
            class="form-input"
            [class.error]="error()"
            maxlength="6"
            pattern="[0-9]*"
            inputmode="numeric"
            [disabled]="loading()"
          />
          <p class="form-hint">Check your email for the verification code</p>
        </div>
      }

      @if (error()) {
        <div class="error-message">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ error() }}</span>
        </div>
      }

      <button
        type="submit"
        pButton
        [label]="showOtpStep() ? 'Verify Code' : 'Sign In'"
        [icon]="showOtpStep() ? 'pi pi-check' : 'pi pi-sign-in'"
        [loading]="loading()"
        class="submit-button"
      ></button>

      @if (showOtpStep()) {
        <button
          type="button"
          pButton
          label="Back"
          icon="pi pi-arrow-left"
          (click)="backToPassword()"
          [disabled]="loading()"
          class="back-button"
          styleClass="p-button-text"
        ></button>
      }

      @if (!showOtpStep()) {
        <div class="auth-footer">
          <p>
            Don't have an account?
            <a routerLink="/register" class="auth-link">Register here</a>
          </p>
          <a routerLink="/forgot-password" class="auth-link forgot-link">Forgot Password?</a>
        </div>
      }
    </form>
  </div>
</div>
